import type { FunctionComponent, SVGProps } from 'react';

export const MicrophoneIcon: FunctionComponent<SVGProps<SVGSVGElement>> = ({ height = 12, width = 12, ...props }) => (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" aria-hidden={true} {...props}>
        <path d="M12 1a4 4 0 0 0-4 4v7a4 4 0 0 0 8 0V5a4 4 0 0 0-4-4Z" fill="currentColor" />
        <path
            d="M19 10v2a7 7 0 0 1-14 0v-2H3v2a9 9 0 0 0 8 8.94V23h2v-2.06A9 9 0 0 0 21 12v-2h-2Z"
            fill="currentColor"
        />
    </svg>
);
